<template>
    <div data-name="select" v-if="list && list.length">
        <a-select
            allowClear
            :value="value"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            :placeholder="placeholder"
            :showSearch="showSearch"
            @change="handleChange">
                <a-icon slot="suffixIcon" type="caret-down"/>
                <a-select-option v-for="item in list" :value="item.id || item" :key="item.id || item">
                    <Campaign :data="item" v-if="type==='campaigns'"/>
                    <span v-else>{{item}}</span>
                </a-select-option>
        </a-select>
    </div>
</template>

<script>
import { reactive,ref, computed } from '@vue/composition-api'
import Icon from '@/components/Theme/Icon'
import Button from '../../Button'
import { truncate } from '../../../../../core/filters'
import Campaign from '../TableComponents/Campaign'

export default {
    name: 'Select',
    components: {
        Icon,
        Button,
        Campaign
    },
    filters: {
        truncate
    },
    props: {
        list: Array,
        type: String,
        filter: String,
        defaultValue: [String, Object],
        placeholder: String,
        showSearch: Boolean
    },
    setup(props, context) {
        const handleChange = (value) => {
            context.emit('setFilter', props.filter, value)
        }
        const value = computed(() => {
            return (props.defaultValue && props.defaultValue.id || props.defaultValue) || undefined
        })


        const filterOption = (input, option) => {
            return option.componentOptions.children[0].componentOptions.propsData.data.title.toLowerCase().includes(input.toLowerCase())
        }

        return {
            handleChange,
            filterOption,
            value,
        }
    }    
}
</script>